<template>
  <div>
    <ButtonComponent
      :label="data.name"
      :icon="data.icon"
      :theme="data.theme"
      @click="onClick"
      :class="{
        'elder-button--disabled': config.disabled,
        'elder-button--invalid': config.invalid,
      }"
      :promise="promise"
      :loading-label="config.loadingLabel"
      :success-label="config.successLabel"
    />

    <ActionModal v-if="dialog" @close="reset" @submit="submit" :value="data" :promise="promise"> </ActionModal>
  </div>
</template>

<script>
import ActionModal from '@/components/Actions/Modal.vue'
import DraftApi from '@/api/Draft'

import { AlertComponent as Alert } from 'vue-elder-alert'

export default {
  props: {
    item: Object,
    action: Function,
    advanced: Boolean,
    invalid: Boolean,
    type: {
      type: String,
      required: true,
      validator: value => ['publish', 'reset'].includes(value),
    },
  },
  watch: {
    dialog: {
      handler: 'fetch',
    },
  },
  data() {
    return {
      isFetching: false,
      items: [],
      promise: null,
      dialog: false,
    }
  },
  computed: {
    config() {
      const configMap = {
        publish: {
          name: this.advanced ? this.$t('publishDraftAdvanced') : this.$t('publish'),
          loadingLabel: this.$t('publishes'),
          successLabel: this.$t('published'),
          // icon: 'fa-pro-light:rocket',
          confirm: this.$t('confirm'),

          description: this.advanced ? this.$t('publishDraftInformationAdvanced') : this.$t('publishDraftInformation'),
          fetchItems: this.advanced,
          disabled: !Boolean(this.item),
          invalid: this.invalid,
        },
        reset: {
          name: this.advanced ? this.$t('revertDraftAdvanced') : this.$t('revertDraft'),
          icon: 'fa-pro-light:rotate-left',
          confirm: this.$t('reset'),
          description: this.advanced ? this.$t('revertDraftInformationAdvanced') : this.$t('revertDraftInformation'),
          fetchItems: this.advanced,
          disabled: !Boolean(this.item),
          invalid: this.invalid,
        },
      }

      return configMap[this.type]
    },

    data() {
      const { name, icon, confirm, tooltip, description } = this.config

      return {
        name,
        theme: this.type === 'publish' && !this.advanced ? 'secondary' : 'default',
        save: true,
        icon,
        labels: {
          confirm,
          tooltip,
        },
        options: [
          {
            key: 'info',
            component: 'Html',
            options: {
              props: {
                style: 'white-space: pre-line',
                value: description,
              },
              size: 2,
            },
          },
          this.type === 'publish' && !this.advanced
            ? {
                key: 'hidePublishModal',
                label: this.$t('hideOnNextPublish'),
                component: 'Checkbox',
                options: {
                  size: 2,
                  props: {
                    sublabel: this.$t('contentPublishedDirectly'),
                  },
                },
              }
            : null,

          this.checklistComponent,
        ].filter(Boolean),
      }
    },

    checklistComponent() {
      if (!this.items.length || this.isFetching) return

      const categoryCounts = this.items.reduce((acc, item) => {
        acc[item.category] = (acc[item.category] || 0) + 1
        return acc
      }, {})

      let items = this.items.map(item => {
        return {
          value: item.draftId,
          label: item.name,
          sublabel: this.$tc(item.action),
          category: this.$tc(item.category, categoryCounts[item.category]),
        }
      })

      return {
        key: 'selected',
        component: 'Checklist',
        options: {
          size: 2,
          validation: 'required',
          props: {
            selectAll: true,
            groupBy: { path: 'category', label: 'category' },
            items: items,
            default: items.map(v => v.value),
          },
        },
      }
    },
  },
  methods: {
    onClick(e) {
      if (this.config.disabled) return
      this.dialog = true
    },

    reset() {
      this.items = []
      this.dialog = false
    },

    submit(data = {}) {
      this.promise = Promise.resolve(this.action(data)).then(() => this.reset())
    },

    fetch() {
      if (!this.item || !this.dialog || !this.config.fetchItems) return

      this.isFetching = true

      const promises = [
        DraftApi.descendants(this.item.id).then(items => {
          this.items = items
        }),
      ]

      Promise.all(promises).then(() => (this.isFetching = false))
    },
  },
  components: {
    ActionModal,
    Alert,
  },
}
</script>

<style lang="scss"></style>
